import { Box, ButtonBase, Grid, Icon, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { getImage } from '@shared/utils/imageFormat';
import { useAppenderStyle } from './appender.style';
import { ITemplateListProps } from './interface/appender.interface';

const TemplateList = ({
  savedList = [],
  templates,
  enabled,
  onSelect,
  onEdit,
}: ITemplateListProps) => {
  const s = useAppenderStyle(useTheme());

  return (
    <Grid container spacing={1}>
      {savedList.map((st) => (
        <Grid key={st.id} size={{ xs: 12, sm: 6 }} sx={s.templateHolder}>
          <ButtonBase
            sx={{
              ...s.img,
              ...(enabled(st.type) && s.clickImg),
            }}
            disabled={!enabled(st.type)}
            onClick={() => onSelect(st)}
            style={{
              backgroundImage: st.picture
                ? `url(${getImage(st.picture, 'small', null, 'managers')})`
                : '',
            }}
          >
            <Box sx={s.addButton}>
              <Icon>{templates[st.type] ? templates[st.type].icon : ''}</Icon>
              ADD
            </Box>
          </ButtonBase>
          <Box sx={s.stInfo}>
            <Typography color="textPrimary">{st.title}</Typography>
            {st.description && (
              <Typography color="textSecondary">{st.description}</Typography>
            )}
          </Box>
          {onEdit && (
            <Box>
              <IconButton onClick={() => onEdit(st)} size="small" sx={s.edit}>
                <Icon>edit</Icon>
              </IconButton>
            </Box>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default TemplateList;
